import React from "react";
import { useState } from "react";
import '../Styles/MedicalComboRegister.scss';
import DateHelpers from '../Helper/DateHelpers.js';
import InputValidation from "../Helper/InputValidation.js";
import { parseISO } from "date-fns";

function MedicalComboUpdate({medicalInformation, setMedicalInformation, page1Next, setPage1Next, handleSubmit}) {
console.log("Medical Information", medicalInformation)
   // Updates 
   function handleChange(member, isSet) {
      console.log("Medical Information", medicalInformation)
      const keys = Object.keys(medicalInformation)
      const key = keys.find(element => {
         return element === member
      })
      setMedicalInformation({ ...medicalInformation, [key]: (isSet)})
   }

   const FormattedTetanusShotDate         = DateHelpers.getFormattedDate(medicalInformation.last_tetanus_shot_dt)
   const FormattedPolicyHolderBirthDate   = DateHelpers.getFormattedDate(medicalInformation.policy_holder_bd)

   const preexistingConditionsColumn1 =
      [
         { display: "Diabetes/Hypoglycemia",    value: "has_diab_or_hypgly"},
         { display: "Heart condition/problems", value: "has_heart_condition"},
         { display: "Epilepsy",                 value: "has_epilepsy"},
         { display: "Environmental Allergies",  value: "has_env_allergies"},
         { display: "Heat exhaustion/problems", value: "has_heat_problem"},
      ];
   const preexistingConditionsColumn2 =
      [
         { display: "Thyroid Problems",    value: "has_thyroid_problem"},
         { display: "Lupus",               value: "has_lupus"},
         { display: "High Blood Pressure", value: "has_high_bld_press"},
         { display: "Asthma",              value: "has_asthma"},
      ];

   const [invalidInsuranceCompanyName,             setInvalidInsuranceCompanyName] = useState(false)
   const [invalidInsuranceIdNumber,                   setInvalidInsuranceIdNumber] = useState(false)
   const [invalidInsuranceGroupPolicyNumber, setInvalidInsuranceGroupPolicyNumber] = useState(false)
   const [invalidPolicyHolderName,                    setInvalidePolicyHolderName] = useState(false)
   const [invalidPolicyHolderBirthDate,           setInvalidPolicyHolderBirthdate] = useState(false)
   const [invalidLastTetanusShotDate,               setInvalidLastTetanusShotDate] = useState(false)

   function ValidateMedicalInformation()
   {
      // Insurance company name exists
      let isError = false
      if(medicalInformation.insurance_cmpy === ""){
         isError = true
         setInvalidInsuranceCompanyName(true)
      }
      // Insurance ID number exists
      if(medicalInformation.insurance_id_num === ""){
         isError = true
         setInvalidInsuranceIdNumber(true)
      }
      // Insurance group policy number exists
      if(medicalInformation.insurance_group_num === ""){
         isError = true
         setInvalidInsuranceGroupPolicyNumber(true)
      }
      // Policy holder name exists
      if(medicalInformation.policy_holder_name === ""){
         isError = true
         setInvalidePolicyHolderName(true)
      }
      // Policy holder birthdate exists
      if(medicalInformation.policy_holder_bd === ""){
         isError = true
         setInvalidPolicyHolderBirthdate(true)
      }
      // Last tetanus shot date exists
      if(medicalInformation.last_tetanus_shot_dt === ""){
         isError = true
         setInvalidLastTetanusShotDate(true)
      }
      if(isError === false){
         handleSubmit()
      }
   }

   return (
      <div className="InsuranceMedicalContent">
         <div className="InsuranceMedicalContainer">
            <form>
               <h2>Medical and Insurance Information</h2>
               <h4>Insurance Info</h4>
               <div className='companyID'>
                  <div className='companyIDInput'>
                     {invalidInsuranceCompanyName === true &&
                        <div className="InsuranceCompanyNameError">
                           * Insurance company name required
                        </div>
                     }
                     <label>Insurance Company: </label>
                     <input
                        type="text"
                        value={medicalInformation.insurance_cmpy}
                        onChange={(event) =>{
                            setMedicalInformation({ ...medicalInformation, insurance_cmpy: (event.target.value)})
                            setInvalidInsuranceCompanyName(false)
                           }}
                     />
                  </div>
                  <div className='companyIDInput'>
                     {invalidInsuranceIdNumber === true &&
                        <div className="InsuranceIdError">
                           * Insurance ID number required
                        </div>
                     }
                     <label>ID Number: </label>
                     <input
                        type="text"
                        value={medicalInformation.insurance_id_num}
                        onChange={(event) => {
                           setMedicalInformation({ ...medicalInformation, insurance_id_num: InputValidation.ValidateInputForInsuranceNumbers(event.target.value)})
                           setInvalidInsuranceIdNumber(false)
                        }}
                     />
                  </div>
               </div>
               <div className="numberName">
                  <div className='numberNameInput'>
                     {invalidInsuranceGroupPolicyNumber === true &&
                        <div className="InsuranceGroupNumberError">
                           * Insurance group number required
                        </div>
                     }
                     <label>Group Policy Number </label>
                     <input
                        type="text"
                        value={medicalInformation.insurance_group_num}
                        onChange={(event) => { 
                           setMedicalInformation({ ...medicalInformation, insurance_group_num: InputValidation.ValidateInputForInsuranceNumbers(event.target.value)})
                           setInvalidInsuranceGroupPolicyNumber(false)
                        }}
                     />
                  </div>
                  <div className='numberNameInput'>
                     {invalidPolicyHolderName === true &&
                        <div className="InsurancePolicyHolderNameError">
                           * Insurance policy holder name required
                        </div>
                     }
                     <label>Name of Policy Holder:</label>
                     <input
                        type="text"
                        value={medicalInformation.policy_holder_name}
                        onChange={(event) => { 
                           setMedicalInformation({ ...medicalInformation, policy_holder_name: (event.target.value) })
                           setInvalidePolicyHolderName(false)
                        }}
                     />
                  </div>
               </div>
               <div className='birthdayStatus'>
                  <div className='birthdayInput'>
                     {invalidPolicyHolderBirthDate === true &&
                        <div className="InsurancePolicyHolderBirthdateError">
                           * Insurance policy holder birth date required
                        </div>
                     }
                     <label>Birthdate of Policy Holder</label>
                     <input
                        type="date"
                        value={FormattedPolicyHolderBirthDate}
                        onChange={(event) => { 
                           setMedicalInformation({ ...medicalInformation, policy_holder_bd: (event.target.value) })
                           setInvalidPolicyHolderBirthdate(false)
                           }}
                     />
                  </div>
               </div>
               <hr></hr>
               <h4>Medical Info</h4>
               <p>Prexisting Conditions: <br />
                  Please check the appropriate box/boxes <br />
                  This will be kept confidential
               </p>
               <div className="preConditionsCheckboxes">
                  <div className="preConditionsCheckboxesColumn1">
                     {preexistingConditionsColumn1.map((condition, index) => {
                        return (
                           <div className="preConditionsCheckboxesInput">
                              <input type="checkbox"
                              // Anytime a change occurs to any of the check boxes!  Prove it! 
                              onChange={(event)=>handleChange(condition.value, event.target.checked)}
                              // {...handleUpdate(condition.value)}
                              checked={medicalInformation[condition.value]}
                              />
                              <>&nbsp;&nbsp;&nbsp;</>
                              {condition.display}
                           </div>
                        );
                     })}
                  </div>
                  <div className="preConditionsCheckboxesColumn2">
                     {preexistingConditionsColumn2.map((condition, index) => {
                        return (
                           <div className="preConditionsCheckboxesInput">
                              <input type="checkbox" 
                              onChange={(event)=>handleChange(condition.value, event.target.checked)}
                              checked={medicalInformation[condition.value]}
                              />
                              <>&nbsp;&nbsp;&nbsp;</>
                              {condition.display}
                           </div>
                        );
                     })}
                  </div>
               </div>
               <div className='allergiesFirstRow'>
                  <div className='AllergiesInput'>
                     <label>Drug Allergy Name: </label>
                     <input
                        type="text"
                        value={medicalInformation.drug_allergy_name}
                        onChange={(event) => setMedicalInformation({ ...medicalInformation, drug_allergy_name: (event.target.value) })}
                     />
                     <label>Emergency Action Taken:</label>
                     <input
                        type="text"
                        value={medicalInformation.drug_allergy_emergency_action}
                        onChange={(event) => setMedicalInformation({ ...medicalInformation, drug_allergy_emergency_action: (event.target.value) })}
                     />
                  </div>
                  <div className='AllergiesInput'>
                     <label>Food Allergy Name: </label>
                     <input
                        type="text"
                        value={medicalInformation.food_allergy_name}
                        onChange={(event) => setMedicalInformation({ ...medicalInformation, food_allergy_name: (event.target.value) })}
                     />
                     <label>Emergency Action Taken:</label>
                     <input
                        type="text"
                        value={medicalInformation.food_allergy_emergency_action}
                        onChange={(event) => setMedicalInformation({ ...medicalInformation, food_allergy_emergency_action: (event.target.value) })}
                     />
                  </div>
               </div>
               <div className="allergiesSecondRow">
                  <div className='allergiesRow2Input'>
                    <label>Other Allergy Name: </label>
                     <input
                        type="text"
                        value={medicalInformation.other_allergy_name}
                        onChange={(event) => setMedicalInformation({ ...medicalInformation, other_allergy_name: (event.target.value) })}
                     />
                     <label>Emergency Action Taken:</label>
                     <input
                        type="text"
                        value={medicalInformation.other_allergy_emergency_action}
                        onChange={(event) => setMedicalInformation({ ...medicalInformation, other_allergy_emergency_action: (event.target.value) })}
                     />
                  </div>
                  <div className='allergiesRow2Input'>
                    <label>Medication Name: </label>
                     <input
                        type="text"
                        value={medicalInformation.medication_name}
                        onChange={(event) => setMedicalInformation({ ...medicalInformation, medication_name: (event.target.value) })}
                     />
                     <label>Medication dose:</label>
                     <input
                        type="text"
                        value={medicalInformation.medication_dose}
                        onChange={(event) => setMedicalInformation({ ...medicalInformation, medication_dose: (event.target.value) })}
                     />
                  </div>
               </div>
               <div className="medicationsTextBoxes">
                  <div className='medicationsTextBoxesInput'>
                     {invalidLastTetanusShotDate === true &&
                        <div className="LastTetanusShotDateError">
                           * Last tetanus shot date required
                        </div>
                     }
                     <label>Date of last tetanus shot:</label>
                     <input
                        type="date"
                        value={FormattedTetanusShotDate} //medicalInformation.last_tetanus_shot_dt
                        onChange={(event) => { 
                           setMedicalInformation({ ...medicalInformation, last_tetanus_shot_dt: (event.target.value) })
                           setInvalidLastTetanusShotDate(false)
                        }}
                     />
                  </div>
               </div>
            </form>
            {(invalidInsuranceCompanyName === true  || invalidInsuranceIdNumber === true ||
              invalidInsuranceGroupPolicyNumber === true || invalidPolicyHolderName === true || 
              invalidPolicyHolderBirthDate || invalidLastTetanusShotDate === true)   &&
               <div className="medicalInfoErrorMessage">
                  Please correct the above error(s)
               </div>
            }
            <div className="medicalInsuranceButtonsContainer">
               <div className="medicalInsuranceButtons">
                  <div className='medicalInsurancePreviousButton'>
                     <button className='prevButton' onClick={() => setPage1Next(page1Next - 1)}>
                        Previous
                     </button>
                  </div>
                  <div className="medicalInsuranceNextButton">
                     <button className="nextButton" type='submit' onClick={() => ValidateMedicalInformation()}>
                        Next
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default MedicalComboUpdate;
